import { getStore } from '../store/store';
import { SuggestionKind } from 'owa-search-service';
export default function queryIncludesKQLSuggestion() {
    var searchStore = getStore();
    var suggestionPills = searchStore.suggestionPills;
    // If there aren't any pills in the store, return false.
    if (!suggestionPills || suggestionPills.size === 0) {
        return false;
    }
    // If there are any persona pills in the store, return true.
    var personaPills = suggestionPills
        .values()
        .filter(function (pill) { return pill.kind === SuggestionKind.People; });
    if (personaPills.length > 0) {
        return true;
    }
    // If no conditions have been hit, then query doesn't include KQL.
    return false;
}
//# sourceMappingURL=queryIncludesKQLSuggestion.js.map